"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = void 0;
require("@ori-ui/license");
var _material = require("@ori-ui/mui-bundle/material");
var _react = require("react");
var _theme = _interopRequireDefault(require("../theme"));
var _jsxRuntime = require("react/jsx-runtime");
const ThemeProvider = ({
  children,
  theme = _theme.default
}) => {
  const internalTheme = (0, _react.useMemo)(() => {
    if (typeof theme === 'function') {
      return theme(_theme.default);
    }
    return theme;
  }, [theme]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ThemeProvider, {
    theme: internalTheme,
    children: children
  });
};
exports.ThemeProvider = ThemeProvider;
